module.exports = __webpack_public_path__ + "static/media/profile.5acb59f9.jpeg";